// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Import for authentication
import { getFirestore } from "firebase/firestore"; // Import for Firestore
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqH4UjXKGKGL0Uajad52ZUQ-44nkkuRUE",
  authDomain: "ev-recharge-64ea7.firebaseapp.com",
  projectId: "ev-recharge-64ea7",
  storageBucket: "ev-recharge-64ea7.appspot.com",
  messagingSenderId: "201112438250",
  appId: "1:201112438250:web:b4f30285f60fb6a3b25e93",
  measurementId: "G-BR8WND066P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firebase Authentication and Firestore
const auth = getAuth(app);
const db = getFirestore(app);

// Export the auth and db instances
export { auth, db };